import { CHAIN as PROBE_CHAIN, KEPLR_CHAIN_INFO } from "../probes/keplr-send/config.mjs";

export const CHAIN = Object.freeze({
  ...PROBE_CHAIN,
  checkoutTypeUrl: "/ipi.checkout.v1.MsgExecuteCheckoutV2",
});

export { KEPLR_CHAIN_INFO };

export const SEND_FEE = Object.freeze({
  amount: (BigInt(CHAIN.gasPrice) * BigInt(CHAIN.gasLimit)).toString(),
  gasLimit: CHAIN.gasLimit,
});

export const CHECKOUT_FEE = Object.freeze({
  amount: "300000000000000",
  gasLimit: "200000",
});

export const CHECKOUT_PROTOCOL = Object.freeze({
  domain: "IPI_CHECKOUT_V2_TERMINAL_AUTHORIZATION",
  version: 2,
  signatureAlgorithm: "secp256k1-sha256-p1363-low-s-v1",
  requestLifetimeMinMs: 300_000,
  requestLifetimeMaxMs: 900_000,
  allowedClockSkewMs: 30_000,
});

export const STORAGE_KEYS = Object.freeze({
  receipts: "ipi.wallet.real.receipts.v1",
});
